import { toggle_off, toggle_on } from "../../../assets/imgs";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import VideocamIcon from "@mui/icons-material/Videocam";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import moment from "moment";

export const groupDashboard = [
  {
    id: 1,
    title: "No of New Alerts",
    count: 0,
    icon: (
      <NotificationsActiveIcon style={{ color: "orange" }} fontSize="large" />
    ),
  },
  {
    id: 3,
    title: "No of Allocated Alerts",
    count: 0,
    icon: (
      <AssignmentTurnedInIcon
        style={{ color: "blueviolet" }}
        fontSize="large"
      />
    ),
  },
  {
    id: 3,
    title: "No of Closed Alerts",
    count: 0,
    icon: <DoneAllIcon style={{ color: "green" }} fontSize="large" />,
  },
  {
    id: 4,
    title: "Re-Assigned Alerts",
    count: 0,
    icon: <DoneAllIcon style={{ color: "green" }} fontSize="large" />,
  },
];

export const admin_list = [
  {
    name: "RamKumar",
    role: "Admin",
    user: "Aravind",
    email: "ramkumar@gmail.com",
    password: "Ramkumar",
    status: 1,
    type: "Mobile",
    number: "9878098077",
    toggle: "on",
    status: "1",
    deviceId: "KW-038",
    client: "Device1",
    assigned: "Sathish",
    location: "Hyderabad",
    Priname: "Hari",
    devices: "10",
  },
  {
    name: "Varun",
    role: "SuperAdmin",
    user: "Varun",
    email: "varun@gmail.com",
    password: "Varun",
    status: 2,
    type: "CRM",
    number: "9435098077",
    toggle: "off",
    status: "2",
    deviceId: "KW-058",
    client: "Device2",
    assigned: "Sambath",
    location: "Madurai",
  },
  {
    name: "Johan",
    role: "Admin",
    user: "Johan",
    email: "johan@gmail.com",
    password: "Johan",
    type: "Both",
    number: "9878098077",
    toggle: "on",
    status: "1",
    deviceId: "KW-738",
    client: "Device3",
    assigned: "Aravindh",
    location: "Banglore",
  },
  {
    name: "Sathish",
    role: "Admin",
    user: "Sathish",
    email: "sathish@gmail.com",
    password: "Sathish",
    type: "Mobile",
    number: "9888098077",
    toggle: "off",
    status: "1",
    deviceId: "KW-838",
    client: "Device4",
    assigned: "Nivin",
    location: "Chennai",
  },
];
export const role_list = [
  {
    id: 1,
    name: " Admin",
    module_type: " Admin",
    permissions: [
      { id: 1, name: "List", On: toggle_on, off: toggle_off },
      { id: 2, name: "Add", On: toggle_on, off: toggle_off },
      { id: 3, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 4, name: "View", On: toggle_on, off: toggle_off },
      { id: 5, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },

  {
    id: 2,
    name: "Roles",
    module_type: "Roles",
    permissions: [
      { id: 1, name: "List", On: toggle_on, off: toggle_off },
      { id: 2, name: "Add", On: toggle_on, off: toggle_off },
      { id: 3, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 4, name: "View", On: toggle_on, off: toggle_off },
      { id: 5, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: 3,
    name: "User",
    module_type: "User",
    permissions: [
      { id: 1, name: "List", On: toggle_on, off: toggle_off },
      { id: 2, name: "Add", On: toggle_on, off: toggle_off },
      { id: 3, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 4, name: "View", On: toggle_on, off: toggle_off },
      { id: 5, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: 4,
    name: "Call Log",
    module_type: "Call Log",
    permissions: [
      { id: 1, name: "List", On: toggle_on, off: toggle_off },
      { id: 2, name: "Add", On: toggle_on, off: toggle_off },
      { id: 3, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 4, name: "View", On: toggle_on, off: toggle_off },
      { id: 5, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: 5,
    name: "Subscriptions",
    module_type: "Subscriptions",
    permissions: [
      { id: 1, name: "List", On: toggle_on, off: toggle_off },
      { id: 2, name: "Add", On: toggle_on, off: toggle_off },
      { id: 3, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 4, name: "View", On: toggle_on, off: toggle_off },
      { id: 5, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: 6,
    name: "Languages",
    module_type: "Languages",
    permissions: [
      { id: 1, name: "List", On: toggle_on, off: toggle_off },
      { id: 2, name: "Add", On: toggle_on, off: toggle_off },
      { id: 3, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 4, name: "View", On: toggle_on, off: toggle_off },
      { id: 5, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
];

export const modules = [
  {
    id: 1,
    module_type: "Admin",
    code: "Admin",
    type: 1,
    permissions: [
      {
        id: 1,
        module_id: 3,
        permission_type: "List",
        code: "CAN-LIST-ADMINS",
      },
      {
        id: 2,
        module_id: 3,
        permission_type: "Add",
        code: "CAN-ADD-ADMINS",
      },
      {
        id: 3,
        module_id: 3,
        permission_type: "Edit",
        code: "CAN-EDIT-ADMINS",
      },
      {
        id: 4,
        module_id: 3,
        permission_type: "View",
        code: "CAN-VIEW-ADMINS",
      },
      {
        id: 5,
        module_id: 3,
        permission_type: "Status",
        code: "CAN-STATUS-ADMINS",
      },
      {
        id: 6,
        module_id: 3,
        permission_type: "Delete",
        code: "CAN-DELETE-ADMINS",
      },
    ],
  },
  {
    id: 2,
    module_type: "Roles",
    code: "Roles",
    type: 1,
    permissions: [
      {
        id: 7,
        module_id: 2,
        permission_type: "List",
        code: "CAN-LIST-ROLES",
      },
      {
        id: 8,
        module_id: 2,
        permission_type: "Add",
        code: "CAN-ADD-ROLES",
      },
      {
        id: 9,
        module_id: 2,
        permission_type: "Edit",
        code: "CAN-EDIT-ROLES",
      },
      {
        id: 10,
        module_id: 2,
        permission_type: "View",
        code: "CAN-VIEW-ROLES",
      },
      {
        id: 11,
        module_id: 2,
        permission_type: "Status",
        code: "CAN-STATUS-ROLES",
      },
      {
        id: 12,
        module_id: 2,
        permission_type: "Delete",
        code: "CAN-DELETE-ROLES",
      },
    ],
  },
  {
    id: 3,
    module_type: "USER",
    code: "USER",
    type: 1,
    permissions: [
      {
        id: 13,
        module_id: 3,
        permission_type: "List",
        code: "CAN-LIST-USER",
      },
      {
        id: 14,
        module_id: 3,
        permission_type: "Add",
        code: "CAN-ADD-USER",
      },
      {
        id: 15,
        module_id: 3,
        permission_type: "Edit",
        code: "CAN-EDIT-USER",
      },
      {
        id: 16,
        module_id: 3,
        permission_type: "View",
        code: "CAN-VIEW-USER",
      },
      {
        id: 17,
        module_id: 3,
        permission_type: "Status",
        code: "CAN-STATUS-USER",
      },
      {
        id: 18,
        module_id: 3,
        permission_type: "Delete",
        code: "CAN-DELETE-USER",
      },
    ],
  },
  {
    id: 4,
    module_type: "Department",
    code: "Department",
    type: 1,
    permissions: [
      {
        id: 19,
        module_id: 4,
        permission_type: "List",
        code: "CAN-LIST-DEPARTMENT",
      },
      {
        id: 20,
        module_id: 4,
        permission_type: "Add",
        code: "CAN-ADD-DEPARTMENT",
      },
      {
        id: 21,
        module_id: 4,
        permission_type: "Edit",
        code: "CAN-EDIT-DEPARTMENT",
      },
      {
        id: 22,
        module_id: 4,
        permission_type: "View",
        code: "CAN-VIEW-DEPARTMENT",
      },
      {
        id: 23,
        module_id: 4,
        permission_type: "Status",
        code: "CAN-STATUS-DEPARTMENT",
      },
      {
        id: 24,
        module_id: 4,
        permission_type: "Delete",
        code: "CAN-DELETE-DEPARTMENT",
      },
    ],
  },
  {
    id: 4,
    module_type: "Location",
    code: "Location",
    type: 1,
    permissions: [
      {
        id: 19,
        module_id: 5,
        permission_type: "List",
        code: "CAN-LIST-LOCATION",
      },
      {
        id: 20,
        module_id: 5,
        permission_type: "Add",
        code: "CAN-ADD-LOCATION",
      },
      {
        id: 21,
        module_id: 5,
        permission_type: "Edit",
        code: "CAN-EDIT-LOCATION",
      },
      {
        id: 22,
        module_id: 5,
        permission_type: "View",
        code: "CAN-VIEW-LOCATION",
      },
      {
        id: 23,
        module_id: 5,
        permission_type: "Status",
        code: "CAN-STATUS-LOCATION",
      },
      {
        id: 24,
        module_id: 5,
        permission_type: "Delete",
        code: "CAN-DELETE-LOCATION",
      },
    ],
  },
];

export const siteDashboardDetails = [
  {
    id: 1,
    name: "Headquarters",
    adminCount: 4,
    groups: {
      group1: 10,
      group2: 8,
      group3: 12,
    },
    devices: 12,
    newAlerts: 5,
    allocatedAlerts: 7,
    closedAlerts: 9,
    icon: <HomeWorkIcon color="secondary" fontSize="large" />,
  },
  {
    id: 2,
    name: "Warehouse - East",
    adminCount: 3,
    groups: {
      group1: 6,
      group2: 4,
      group3: 7,
    },
    devices: 8,
    newAlerts: 2,
    allocatedAlerts: 5,
    closedAlerts: 6,
    icon: <HomeWorkIcon color="secondary" fontSize="large" />,
  },
  {
    id: 3,
    name: "Factory Unit - 1",
    adminCount: 5,
    groups: {
      group1: 15,
      group2: 11,
      group3: 9,
    },
    devices: 15,
    newAlerts: 4,
    allocatedAlerts: 9,
    closedAlerts: 12,
    icon: <HomeWorkIcon color="secondary" fontSize="large" />,
  },
  {
    id: 4,
    name: "Regional Office",
    adminCount: 2,
    groups: {
      group1: 5,
      group2: 6,
      group3: 4,
    },
    devices: 6,
    newAlerts: 3,
    allocatedAlerts: 4,
    closedAlerts: 5,
    icon: <HomeWorkIcon color="secondary" fontSize="large" />,
  },
  {
    id: 5,
    name: "Support Center",
    adminCount: 6,
    groups: {
      group1: 12,
      group2: 9,
      group3: 10,
    },
    devices: 20,
    newAlerts: 7,
    allocatedAlerts: 11,
    closedAlerts: 13,
    icon: <HomeWorkIcon color="secondary" fontSize="large" />,
  },
];

export const superDashboard = [
  {
    id: 1,
    title: "No of Admin",
    count: 0,
    icon: <PeopleIcon color="primary" fontSize="large" />,
  },
  {
    id: 2,
    title: "No of Company",
    count: 0,
    icon: <BusinessIcon color="secondary" fontSize="large" />,
  },
  {
    id: 3,
    title: "No of Camera Devices",
    count: 0,
    icon: <VideocamIcon style={{ color: "teal" }} fontSize="large" />,
  },
  {
    id: 4,
    title: "No of New Alerts",
    count: 0,
    icon: (
      <NotificationsActiveIcon style={{ color: "orange" }} fontSize="large" />
    ),
  },
  {
    id: 5,
    title: "No of Allocated Alerts",
    count: 0,
    icon: (
      <AssignmentTurnedInIcon
        style={{ color: "blueviolet" }}
        fontSize="large"
      />
    ),
  },
  {
    id: 6,
    title: "No of Closed Alerts",
    count: 0,
    icon: <DoneAllIcon style={{ color: "green" }} fontSize="large" />,
  },
];

export const DashboardCompanyList = [
  {
    id: 1,
    name: "TechCorp Pvt Ltd",
    icon: <BusinessIcon color="primary" fontSize="large" />,
  },
  {
    id: 2,
    name: "Green Builders",
    icon: <BusinessIcon color="primary" fontSize="large" />,
  },
  {
    id: 3,
    name: "CityMart Retail",
    icon: <BusinessIcon color="primary" fontSize="large" />,
  },
  {
    id: 4,
    name: "Mega Industries",
    icon: <BusinessIcon color="primary" fontSize="large" />,
  },
  {
    id: 5,
    name: "ProServices Ltd",
    icon: <BusinessIcon color="primary" fontSize="large" />,
  },
];

export const siteDashboardList = [
  {
    id: 1,
    name: "Headquarters",
    icon: <LocationOnIcon color="secondary" fontSize="large" />,
  },
  {
    id: 2,
    name: "Warehouse - East",
    icon: <LocationOnIcon color="secondary" fontSize="large" />,
  },
  {
    id: 3,
    name: "Factory Unit - 1",
    icon: <LocationOnIcon color="secondary" fontSize="large" />,
  },
  {
    id: 4,
    name: "Regional Office",
    icon: <LocationOnIcon color="secondary" fontSize="large" />,
  },
  {
    id: 5,
    name: "Support Center",
    icon: <LocationOnIcon color="secondary" fontSize="large" />,
  },
];

export const companyList = [
  {
    sno: 1,
    CompanyID: "KNF1",
    companyName: "Alpha Tech Pvt Ltd",
    companyLocation: "Bangalore, India",
    primaryPerson: "Rajesh Kumar",
    mobileNumber: "+91 9876543210",
    email: "knf@gamil.com",
  },
  {
    sno: 2,
    CompanyID: "KNF2",
    companyName: "GreenLeaf Solutions",
    companyLocation: "Mumbai, India",
    primaryPerson: "Priya Sharma",
    mobileNumber: "+91 9123456789",
    email: "knf@gamil.com",
  },
  {
    sno: 3,
    CompanyID: "KNF3",
    companyName: "SkyNet Systems",
    companyLocation: "Hyderabad, India",
    primaryPerson: "Anil Reddy",
    mobileNumber: "+91 9988776655",
    email: "knf@gamil.com",
  },
  {
    sno: 4,
    CompanyID: "KNF4",
    companyName: "Oceanic Enterprises",
    companyLocation: "Chennai, India",
    primaryPerson: "Kavya Menon",
    mobileNumber: "+91 9876012345",
    email: "knf@gamil.com",
  },
  {
    sno: 5,
    CompanyID: "KNF5",
    companyName: "Bright Future Corp",
    companyLocation: "Pune, India",
    primaryPerson: "Rohit Verma",
    mobileNumber: "+91 9123098765",
    email: "knf@gamil.com",
  },
].map((item) => ({
  ...item,
  companyCreatedAt: moment().format("DD-MM-YYYY"),
  adminCreatedAt: moment().format("DD-MM-YYYY"),
}));

export const siteListDummy = [
  {
    id: 1,
    siteName: "Sunrise Residency",
    siteAddress: "45 MG Road, Indiranagar, Bangalore, Karnataka - 560038",
    editing: false,
  },
  {
    id: 2,
    siteName: "Green Valley Apartments",
    siteAddress: "12 Park Street, Salt Lake, Kolkata, West Bengal - 700064",
    editing: false,
  },
  {
    id: 3,
    siteName: "Ocean View Villas",
    siteAddress: "22 Beach Road, Juhu, Mumbai, Maharashtra - 400049",
    editing: false,
  },
  {
    id: 4,
    siteName: "Skyline Towers",
    siteAddress: "Plot No. 18, Sector 62, Noida, Uttar Pradesh - 201301",
    editing: false,
  },
  {
    id: 5,
    siteName: "Lakeview Residency",
    siteAddress: "8 Gandhi Nagar, Adyar, Chennai, Tamil Nadu - 600020",
    editing: false,
  },
];

export const companyDetails = [
  { companyId: "C001", companyName: "TechNova Solutions" },
  { companyId: "C002", companyName: "GreenField Industries" },
  { companyId: "C003", companyName: "NextGen Infotech" },
  { companyId: "C004", companyName: "UrbanEdge Constructions" },
  { companyId: "C005", companyName: "BrightSky Retail" },
  { companyId: "C006", companyName: "AquaPure Systems" },
  { companyId: "C007", companyName: "Skyline Architects" },
  { companyId: "C008", companyName: "FutureTech Labs" },
  { companyId: "C009", companyName: "Sunrise Foods Pvt Ltd" },
  { companyId: "C010", companyName: "EcoSmart Energy" },
];

export const sitesCompanyList = [
  {
    companyId: "C001",
    companyName: "TechNova Solutions",
    companyAdmin: "Rajesh Kumar",
    companyAdminEmail: "rajesh.kumar@technova.com",
    siteName: "TechNova Hub",
    siteCode: "TNH-1001",
    siteLocation: "Bangalore, India",
    siteAdminName: "Anita Sharma",
    siteAdminEmail: "anita.sharma@technova.com",
    siteAdminMobile: "+91-9876543210",
  },
  {
    companyId: "C002",
    companyName: "GreenField Industries",
    companyAdmin: "Suresh Menon",
    companyAdminEmail: "suresh.menon@greenfield.com",
    siteName: "GreenField Plant 1",
    siteCode: "GFP-2002",
    siteLocation: "Chennai, India",
    siteAdminName: "Divya Ramesh",
    siteAdminEmail: "divya.ramesh@greenfield.com",
    siteAdminMobile: "+91-9123456780",
  },
  {
    companyId: "C003",
    companyName: "NextGen Infotech",
    companyAdmin: "Priya Nair",
    companyAdminEmail: "priya.nair@nextgen.com",
    siteName: "NextGen Tower",
    siteCode: "NGT-3003",
    siteLocation: "Hyderabad, India",
    siteAdminName: "Amit Verma",
    siteAdminEmail: "amit.verma@nextgen.com",
    siteAdminMobile: "+91-9988776655",
  },
  {
    companyId: "C004",
    companyName: "UrbanEdge Constructions",
    companyAdmin: "Manoj Pillai",
    companyAdminEmail: "manoj.pillai@urbanedge.com",
    siteName: "UrbanEdge HQ",
    siteCode: "UEH-4004",
    siteLocation: "Mumbai, India",
    siteAdminName: "Sneha Kapoor",
    siteAdminEmail: "sneha.kapoor@urbanedge.com",
    siteAdminMobile: "+91-9012345678",
  },
  {
    companyId: "C005",
    companyName: "BrightSky Retail",
    companyAdmin: "Anil Gupta",
    companyAdminEmail: "anil.gupta@brightsky.com",
    siteName: "BrightSky Mall",
    siteCode: "BSM-5005",
    siteLocation: "Delhi, India",
    siteAdminName: "Ritika Singh",
    siteAdminEmail: "ritika.singh@brightsky.com",
    siteAdminMobile: "+91-9090909090",
  },
].map((item) => ({
  ...item,
  siteAddress: "45 MG Road, Indiranagar, Bangalore, Karnataka - 560038",
  createdBy: "Admin",
  dateTime: `${Math.floor(Math.random() * 56) + 5} mins`,
  companyCreatedAt: moment().format("DD-MM-YYYY"),
  adminCreatedAt: moment().format("DD-MM-YYYY"),
}));

export const group1 = [
  {
    name: "Alice Johnson",
    email: "alice.johnson@example.com",
    mobile: "+1-202-555-0110",
    createdAt: "2025-01-10",
    alertNotification: true,
    beepSound: true,
  },
  {
    name: "Bob Smith",
    email: "bob.smith@example.com",
    mobile: "+1-202-555-0125",
    createdAt: "2025-02-12",
    alertNotification: false,
    beepSound: false,
  },
  {
    name: "Charlie Brown",
    email: "charlie.brown@example.com",
    mobile: "+1-202-555-0138",
    createdAt: "2025-03-05",
    alertNotification: true,
    beepSound: false,
  },
  {
    name: "Diana Prince",
    email: "diana.prince@example.com",
    mobile: "+1-202-555-0147",
    createdAt: "2025-04-18",
    alertNotification: true,
    beepSound: true,
  },
  {
    name: "Ethan Hunt",
    email: "ethan.hunt@example.com",
    mobile: "+1-202-555-0159",
    createdAt: "2025-05-20",
    alertNotification: false,
    beepSound: false,
  },
];

export const group2 = [
  {
    name: "Fiona Green",
    email: "fiona.green@example.com",
    mobile: "+1-202-555-0166",
    createdAt: "2025-01-22",
    alertNotification: true,
    beepSound: false,
  },
  {
    name: "George White",
    email: "george.white@example.com",
    mobile: "+1-202-555-0174",
    createdAt: "2025-03-11",
    alertNotification: true,
    beepSound: true,
  },
  {
    name: "Hannah Lee",
    email: "hannah.lee@example.com",
    mobile: "+1-202-555-0182",
    createdAt: "2025-04-25",
    alertNotification: false,
    beepSound: false,
  },
];

export const group3 = [
  {
    name: "Ian Black",
    email: "ian.black@example.com",
    mobile: "+1-202-555-0199",
    createdAt: "2025-02-07",
    alertNotification: true,
    beepSound: false,
  },
  {
    name: "Julia Roberts",
    email: "julia.roberts@example.com",
    mobile: "+1-202-555-0203",
    createdAt: "2025-05-15",
    alertNotification: true,
    beepSound: true,
  },
];
export const alertList = [
  {
    sNo: 1,
    alert: "Violation of PPE – No Harness/No Helmet/No Shoes",
    priority: 1,
  },
  { sNo: 2, alert: "Vehicle Collision with Human", priority: 3 },
  { sNo: 3, alert: "Human Under Lifted loads (Falling Objects)", priority: 1 },
  { sNo: 4, alert: "Near Open Pit / Unbarricaded Areas", priority: 2 },
  {
    sNo: 5,
    alert:
      "Mapping Zone Violation of 5 or more person (to be supplied by company)",
    priority: 3,
  },
].map((item) => ({
  ...item,
  escalationTime: `${Math.floor(Math.random() * 56) + 5} mins`,
}));

export const siteDetails = [
  {
    companyId: "S001",
    companyName: "TechNova HQ",
    siteCode: "TN-HQ",
    siteLocation: "Bangalore, India",
    siteAdmin: {
      name: "Rahul Mehta",
      email: "rahul.mehta@technova.com",
      mobile: "+91-9876543210",
    },
  },
  {
    companyId: "S002",
    companyName: "GreenField Plant 1",
    siteCode: "GF-P1",
    siteLocation: "Pune, India",
    siteAdmin: {
      name: "Anita Sharma",
      email: "anita.sharma@greenfield.com",
      mobile: "+91-9123456789",
    },
  },
  {
    companyId: "S003",
    companyName: "NextGen Tower",
    siteCode: "NG-TWR",
    siteLocation: "Hyderabad, India",
    siteAdmin: {
      name: "Vikram Singh",
      email: "vikram.singh@nextgen.com",
      mobile: "+91-9988776655",
    },
  },
  {
    companyId: "S004",
    companyName: "UrbanEdge Residency",
    siteCode: "UE-RES",
    siteLocation: "Mumbai, India",
    siteAdmin: {
      name: "Priya Nair",
      email: "priya.nair@urbanedge.com",
      mobile: "+91-9876001122",
    },
  },
  {
    companyId: "S005",
    companName: "BrightSky Mall",
    siteCode: "BS-MALL",
    siteLocation: "Delhi, India",
    siteAdmin: {
      name: "Karan Patel",
      email: "karan.patel@brightsky.com",
      mobile: "+91-9090909090",
    },
  },
  {
    companyId: "S006",
    companyName: "AquaPure Factory",
    siteCode: "AP-FACT",
    siteLocation: "Chennai, India",
    siteAdmin: {
      name: "Sonal Gupta",
      email: "sonal.gupta@aquapure.com",
      mobile: "+91-9811223344",
    },
  },
  {
    companyId: "S007",
    companyName: "Skyline Design Studio",
    siteCode: "SL-DS",
    siteLocation: "Kolkata, India",
    siteAdmin: {
      name: "Arjun Das",
      email: "arjun.das@skyline.com",
      mobile: "+91-9000011111",
    },
  },
  {
    companyId: "S008",
    companyName: "FutureTech Park",
    siteCode: "FT-PARK",
    siteLocation: "Noida, India",
    siteAdmin: {
      name: "Sneha Kapoor",
      email: "sneha.kapoor@futuretech.com",
      mobile: "+91-9321654789",
    },
  },
  {
    companyId: "S009",
    companyName: "Sunrise Foods Plant",
    siteCode: "SF-PLT",
    siteLocation: "Ahmedabad, India",
    siteAdmin: {
      name: "Ramesh Iyer",
      email: "ramesh.iyer@sunrisefoods.com",
      mobile: "+91-9877001234",
    },
  },
  {
    companyId: "S010",
    companyName: "EcoSmart Solar Farm",
    siteCode: "ES-SF",
    siteLocation: "Jaipur, India",
    siteAdmin: {
      name: "Nikita Rao",
      email: "nikita.rao@ecosmart.com",
      mobile: "+91-9811225566",
    },
  },
];

export const groupUsers = [
  { id: 1, name: "Arjun Mehta emp-001" },
  { id: 2, name: "Priya Sharma emp-002" },
  { id: 3, name: "Ravi Kumar emp-003" },
  { id: 4, name: "Sneha Reddy emp-004" },
  { id: 5, name: "Amit Verma emp-005" },
  { id: 6, name: "Kavya Nair emp-006" },
  { id: 7, name: "Rahul Iyer emp-007" },
  { id: 8, name: "Divya Patel emp-008" },
  { id: 9, name: "Suresh Menon emp-009" },
  { id: 10, name: "Nisha Gupta emp-0010" },
];
export const cameraData = [
  { id: 1, name: "C001" },
  { id: 2, name: "C002" },
  { id: 3, name: "C003" },
  { id: 4, name: "C004" },
  { id: 5, name: "C005" },
  { id: 6, name: "C006" },
  { id: 7, name: "C007" },
  { id: 8, name: "C008" },
  { id: 9, name: "C009" },
  { id: 10, name: "C010" },
];

// Recent Alerts
export const recentAlerts = [
  {
    sno: 1,
    dateTime: "2025-08-24 05:10 PM",
    alertType: "No_Harness",
    severity: 3,
    resourceName: "DB-Cluster-01",
    description: "No Harness / No Helmet / No Shoes",
  },
  {
    sno: 2,
    dateTime: "2025-08-24 04:55 PM",
    alertType: "No_Helmet",
    severity: 2,
    resourceName: "Firewall-01",
    description: "Vehicle Collision with Human",
  },
  {
    sno: 3,
    dateTime: "2025-08-24 04:20 PM",
    alertType: "No_Shoes",
    severity: 1,
    resourceName: "Storage-Server-07",
    description: "Falling Objects",
  },
  {
    sno: 4,
    dateTime: "2025-08-24 03:45 PM",
    alertType: "Vehicle collision with human",
    severity: 2,
    resourceName: "Web-Server-02",
    description: "Unbarricaded Areas",
  },
  {
    sno: 5,
    dateTime: "2025-08-24 03:15 PM",
    alertType: "Danger under lifted load",
    severity: 3,
    resourceName: "Analytics-Service",
    description: "to be supplied by company",
  },
].map((item) => ({
  ...item,
  siteName: "Ninos Site",
}));

// Allocated Alerts
export const allocatedAlerts = [
  {
    sno: 1,
    dateTime: "2025-08-24 05:10 PM",
    alertType: "Violation of PPE",
    severity: 3,
    resourceName: "DB-Cluster-01",
    description: "No Harness / No Helmet / No Shoes",
  },
  {
    sno: 2,
    dateTime: "2025-08-24 04:55 PM",
    alertType: "Vehicle Collision with Human",
    severity: 2,
    resourceName: "Firewall-01",
    description: "Vehicle Collision with Human",
  },
  {
    sno: 3,
    dateTime: "2025-08-24 04:20 PM",
    alertType: "Human Under Lifted loads",
    severity: 1,
    resourceName: "Storage-Server-07",
    description: "Falling Objects",
  },
  {
    sno: 4,
    dateTime: "2025-08-24 03:45 PM",
    alertType: "Near Open Pit",
    severity: 2,
    resourceName: "Web-Server-02",
    description: "Unbarricaded Areas",
  },
  {
    sno: 5,
    dateTime: "2025-08-24 03:15 PM",
    alertType: "Mapping Zone Violation of 5 or more person ",
    severity: 3,
    resourceName: "Analytics-Service",
    description: "to be supplied by company",
  },
].map((item) => ({
  ...item,
  siteName: "Ninos Site",
  allocatedTime: moment().format("DD-MM-YYYY  hh:mm A"),
}));

// Closed Alerts
export const closedAlerts = [
  {
    sno: 1,
    dateTime: "2025-08-24 05:10 PM",
    alertType: "Violation of PPE",
    severity: 3,
    resourceName: "DB-Cluster-01",
    description: "No Harness / No Helmet / No Shoes",
  },
  {
    sno: 2,
    dateTime: "2025-08-24 04:55 PM",
    alertType: "Vehicle Collision with Human",
    severity: 2,
    resourceName: "Firewall-01",
    description: "Vehicle Collision with Human",
  },
  {
    sno: 3,
    dateTime: "2025-08-24 04:20 PM",
    alertType: "Human Under Lifted loads",
    severity: 1,
    resourceName: "Storage-Server-07",
    description: "Falling Objects",
  },
  {
    sno: 4,
    dateTime: "2025-08-24 03:45 PM",
    alertType: "Near Open Pit",
    severity: 2,
    resourceName: "Web-Server-02",
    description: "Unbarricaded Areas",
  },
  {
    sno: 5,
    dateTime: "2025-08-24 03:15 PM",
    alertType: "Mapping Zone Violation of 5 or more person ",
    severity: 3,
    resourceName: "Analytics-Service",
    description: "to be supplied by company",
  },
].map((item) => ({
  ...item,
  siteName: "Ninos Site",
  closedTime: moment().format("DD-MM-YYYY  hh:mm A"),
}));

export const violations = [
  {
    sno: 1,
    cameraId: "C01-TC1",
    typeViolation: "Violation of PPE - No_Harness",
    severity: "1",
  },
  {
    sno: 2,
    cameraId: "C02-TC1",
    typeViolation: "Violation of PPE - No_Helmet",
    severity: "1",
  },
  {
    sno: 3,
    cameraId: "C03-TC2",
    typeViolation: "Violation of PPE - No_Shoes",
    severity: "3",
  },
  {
    sno: 4,
    cameraId: "C04-TC2",
    typeViolation: "Violation of PPE - No_Harness",
    severity: "3",
  },
  {
    sno: 5,
    cameraId: "C05-TC3",
    typeViolation: "Violation of PPE - No_Helmet",
    severity: "1",
  },
  {
    sno: 6,
    cameraId: "C06-TC3",
    typeViolation: "Violation of PPE - No_Shoes",
    severity: "1",
  },
  {
    sno: 7,
    cameraId: "C07-TC4",
    typeViolation: "Violation of PPE - No_Harness",
    severity: "1",
  },
  {
    sno: 8,
    cameraId: "C08-TC4",
    typeViolation: "Violation of PPE - No_Helmet",
    severity: "1",
  },
  {
    sno: 9,
    cameraId: "C09-TC5",
    typeViolation: "Violation of PPE - No_Shoes",
    severity: "2",
  },
  {
    sno: 10,
    cameraId: "C10-TC5",
    typeViolation: "Violation of PPE - No_Harness",
    severity: "1",
  },
];
